var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { ClassBaseDirective } from '../base/classbase.directive';
import { ClassService } from '../../service/class.service';
import { Form } from './questionnaire.service';
var QuestionnaireDirective = /** @class */ (function (_super) {
    __extends(QuestionnaireDirective, _super);
    function QuestionnaireDirective(el, renderer, service) {
        var _this = _super.call(this, el, renderer, service) || this;
        _this.el = el;
        _this.renderer = renderer;
        _this.service = service;
        _this.err_p = _this.renderer.createElement('p');
        return _this;
    }
    QuestionnaireDirective.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    QuestionnaireDirective.prototype.onInit = function () {
    };
    QuestionnaireDirective.prototype.addError = function (msg) {
        var el = this.el.nativeElement.querySelector('.formError');
        var errFlg = (!this.item.form_type ? true : false);
        if (errFlg) {
            if (!el) {
                this.err_text = this.renderer.createText(msg);
                this.renderer.addClass(this.err_p, 'formError');
                this.renderer.appendChild(this.err_p, this.err_text);
                this.renderer.insertBefore(this.el.nativeElement, this.err_p, this.el.nativeElement.firstChild);
            }
        }
        else {
            if (el) {
                this.renderer.removeChild(this.err_p, this.err_text);
                this.renderer.removeChild(this.el.nativeElement, this.err_p);
            }
        }
    };
    QuestionnaireDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[questionnaireDir]'
                },] }
    ];
    /** @nocollapse */
    QuestionnaireDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ClassService }
    ]; };
    QuestionnaireDirective.propDecorators = {
        item: [{ type: Input }]
    };
    return QuestionnaireDirective;
}(ClassBaseDirective));
export { QuestionnaireDirective };
//# sourceMappingURL=questionnaire.directive.js.map